import { ApiClient } from "./client";
import { loadAuthFromStorage } from "../auth/authStorage";

function getTokenFromStorage(): string {
  try {
    if (typeof localStorage === "undefined") return "";
    return loadAuthFromStorage().token;
  } catch {
    return "";
  }
}

const API_ROOT_PATH = "/api";

function normalizePath(p: string): string {
  const path = String(p || "").trim();
  if (!path) return "/api";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  if (path.startsWith("/api/v1/") || path === API_ROOT_PATH) return path;
  if (path.startsWith("/")) return `/api${path}`;
  return `/api/v1/${path}`;
}

// Legacy-style API helper used by some pages.
// Newer code should prefer `useAuth().api` directly.
const client = new ApiClient({
  getToken: () => getTokenFromStorage(),
  onUnauthorized: () => {
    // No-op: AuthProvider handles global logout. This helper is mainly for legacy pages.
  }
});

export const api = {
  req: <T,>(path: string, opts?: RequestInit & { retries?: number }) => client.req<T>(normalizePath(path), opts),
  get: <T,>(path: string) => client.get<T>(normalizePath(path)),
  post: <T,>(path: string, body?: unknown) => client.post<T>(normalizePath(path), body),
  put: <T,>(path: string, body?: unknown) => client.put<T>(normalizePath(path), body),
  delete: <T,>(path: string) => client.del<T>(normalizePath(path)),
  del: <T,>(path: string, opts?: { suppressGlobalErrorToast?: boolean }) =>
    client.del<T>(normalizePath(path), opts),
  blob: (path: string, opts?: RequestInit) => client.blob(normalizePath(path), opts)
};












